// import React, { PureComponent } from 'react';
// import {PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend} from 'recharts';
// import PropTypes from "prop-types";
//
// const COLORS = ['#82ca9d', '#8884d8', '#FFBB28', '#FF8042'];
// const RADIAN = Math.PI / 180;
//
// class SimplePieChart extends PureComponent {
//     static propTypes = {
//         data: PropTypes.arrayOf(PropTypes.shape({
//             Estado: PropTypes.string,
//             Conteo: PropTypes.number,
//         })).isRequired,
//     }
//
//
//   renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, entry }) => {
//     const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
//     const x  = cx + radius * Math.cos(-midAngle * RADIAN);
//     const y = cy  + radius * Math.sin(-midAngle * RADIAN);
//
//    return (
//      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} 	dominantBaseline="central">
//        {`${(percent * 100).toFixed(0)}%`}
//      </text>
//    );
//   }
//
// 	render () {
//         console.log(this.props.data)
//   	return (
//       <ResponsiveContainer height={300} width='100%'>
//         <PieChart onMouseEnter={this.onPieEnter}>
//
//           <Pie
//             data={this.props.data}
//             cx='50%'
//             cy={150}
//             // labelLine={false}
//             label={this.renderCustomizedLabel}
//             outerRadius={100}
//             fill="#8884d8"
//             dataKey="Conteo"
//           >
//             {
//                 this.props.data.map((entry, index) => <Cell key={entry} value ={entry.name} fill={COLORS[index % COLORS.length]} />)
//             }
//             <Legend />
//               <Tooltip />
//           </Pie>
//         </PieChart>
//       </ResponsiveContainer>
//     );
//   }
// }
//
// export default SimplePieChart;

import React, { PureComponent } from 'react';
import { PieChart, Pie, Sector, ResponsiveContainer } from 'recharts';
import PropTypes from "prop-types";

const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
        <g>
            <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
                {payload.name}
            </text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={fill}
            />
            <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
            <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
            <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`PV ${value}`}</text>
            <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
                {`(Rate ${(percent * 100).toFixed(2)}%)`}
            </text>
        </g>
    );
};

export default class SimplePieChart extends PureComponent {
    static demoUrl = 'https://codesandbox.io/s/pie-chart-with-customized-active-shape-y93si';
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.shape({
            Estado: PropTypes.string,
            Conteo: PropTypes.number,
        })).isRequired,
    }
    state = {
        activeIndex: 0,
        data: []
    };

    onPieEnter = (_, index) => {
        this.setState({
            activeIndex: index,
        });
    };


    render() {
        this.setState({
            data: this.props.data
        })
        return (
            <ResponsiveContainer height={300} width='100%' >
                <PieChart width={400} height={400}>
                    <Pie
                        activeIndex={this.state.activeIndex}
                        activeShape={renderActiveShape}
                        data={this.data}
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey="Conteo"
                        onMouseEnter={this.onPieEnter}
                    />
                </PieChart>
            </ResponsiveContainer>
        );
    }
}
